@if (condition) {<i class="fa fa-circle-o-notch fa-spin"></i>}